export function formatDate(dateString: string, withTime?: boolean): string {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
      return '';
  }

  if (!withTime) {
      // Format: "Mar 16, 2025"
      const options: Intl.DateTimeFormatOptions = {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
      };
      return date.toLocaleDateString('en-US', options);
  }

  // Manual format with time: "16/03/2025 - 14:30"
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}
